<template>
  <footer id="footer">
    <div class="info-footer-derek">
      <div class="container-max-width d-flex flex-wrap justify-content-center">
        <div class="col-12 col-md-3 item-info-footer-derek">
          <div class="container-img">
            <img class="mb-2" src="@/assets/img/compra-segura.svg" alt="" />
          </div>
          <p class="title-item-footer-derek">Compra segura y protegida</p>
          <p class="description-item-footer-derek">
            Encriptamos todos tus datos y contamos con todas las certificaciones
            de seguridad.
          </p>
        </div>
        <div class="col-12 col-md-3 item-info-footer-derek">
          <div class="container-img">
            <img class="mb-2" src="@/assets/img/envios.svg" alt="" />
          </div>
          <p class="title-item-footer-derek">Envíos nacionales</p>
          <p class="description-item-footer-derek">
            ¿Sabías qué nuestros productos llegan a más de 800 municipios de
            Colombia?
          </p>
        </div>
        <div class="col-12 col-md-3 item-info-footer-derek">
          <div class="container-img">
            <img class="mb-2" src="@/assets/img/devoluciones.svg" alt="" />
          </div>
          <p class="title-item-footer-derek">Devoluciones sin costo</p>
          <p class="description-item-footer-derek">
            ¿No es tu talla? No te preocupes puedes devolver los productos de
            forma rápida y gratuita.
          </p>
        </div>
      </div>
    </div>
    <news-latter />
    <div class="footer-top container-max-width">
      <div id="footer-1" class="d-block d-md-flex">
        <div class="col-12 d-block d-md-flex">
          <div class="col-12 col-md-4 d-flex align-items-start">
            <div class="d-flex flex-wrap d-md-grid justify-content-between">
              <div class="ps-md-5 col col-md-12 mb-4">
                <svg
                  style="cursor: pointer;"
                  class="mb-auto mb-md-5 me-4 my-2"
                  xmlns="http://www.w3.org/2000/svg"
                  width="100"
                  height="26.237"
                  viewBox="0 0 100 26.237"
                  @click="$router.push({ name: 'Home' })"
                >
                  <g id="DEREK_" transform="translate(-26.5 -23.6)">
                    <path
                      id="Trazado_825754"
                      data-name="Trazado 825754"
                      d="M47.674,49.147H44.222V46.615A10.22,10.22,0,0,1,36.4,49.837c-5.293,0-9.9-3.8-9.9-9.551s4.6-9.551,9.9-9.551,5.524.69,7.825,2.992V23.6h3.452V49.032h0ZM37.2,47.42c4.028,0,7.02-2.647,7.02-7.135s-2.877-7.135-7.02-7.135-7.02,2.647-7.02,7.135,2.877,7.135,7.02,7.135"
                      transform="translate(0 0)"
                      fill="#fff"
                    />
                    <path
                      id="Trazado_825755"
                      data-name="Trazado 825755"
                      d="M66.938,40.272H50.367c.345,3.682,2.647,6.214,6.559,6.214S62.1,45.45,62.8,42.919h3.682c-.69,4.718-5.524,5.984-9.436,5.984C50.482,48.9,46.8,45.335,46.8,39.7s3.913-9.9,10.242-9.9,9.666,3.452,9.666,9.436v1.036h.23Zm-3.682-2.417c0-4.028-3.107-5.639-6.1-5.639a6.434,6.434,0,0,0-6.674,5.639Z"
                      transform="translate(3.06 0.935)"
                      fill="#fff"
                    />
                    <path
                      id="Trazado_825756"
                      data-name="Trazado 825756"
                      d="M66.515,34.458c0-1.381,0-2.647-.115-4.028h3.222c0,1.036.115,2.3.115,3.567h0c1.611-2.877,3.107-3.8,7.135-3.8h1.151v3.107a3.917,3.917,0,0,0-1.611-.23c-4.143,0-6.444,2.877-6.444,6.559v8.516H66.515V34.458Z"
                      transform="translate(6.015 0.995)"
                      fill="#fff"
                    />
                    <path
                      id="Trazado_825757"
                      data-name="Trazado 825757"
                      d="M96.838,40.272H80.267c.345,3.682,2.647,6.214,6.559,6.214S92,45.45,92.7,42.919h3.682c-.69,4.718-5.524,5.984-9.436,5.984C80.382,48.9,76.7,45.335,76.7,39.7s3.913-9.9,10.242-9.9,9.666,3.452,9.666,9.436v1.036h.23Zm-3.682-2.417c0-4.028-3.107-5.639-6.1-5.639a6.434,6.434,0,0,0-6.674,5.639H93.156Z"
                      transform="translate(7.568 0.935)"
                      fill="#fff"
                    />
                    <path
                      id="Trazado_825758"
                      data-name="Trazado 825758"
                      d="M96.4,23.6h3.567V38.675l9.321-7.25h5.063l-9.9,7.595,11.507,10.127h-5.178l-10.817-9.9v9.9H96.4Z"
                      transform="translate(10.537 0)"
                      fill="#fff"
                    />
                  </g>
                </svg>
                <div class="w-100 mt-4 d-flex d-md-none">
                  <a target="_blank" href="https://www.sic.gov.co/">
                    <img
                      src="@/assets/icons/industriaycomercio.svg"
                      aria-label="Icon industria y comercio"
                      class="my-auto mb-4 ms-md-5"
                    />
                  </a>
                </div>
              </div>
              <div class="ps-md-5 mb-5">
                <a
                  href="https://www.facebook.com/derekaddict"
                  target="_blank"
                  class="text-center text-md-start"
                  ><img
                    class="pb-2 pe-2"
                    src="@/assets/icons/facebook.svg"
                    alt=""
                  />
                  Facebook /
                </a>
                <br />
                <a
                  href="https://www.instagram.com/derekaddict/"
                  target="_blank"
                  class="text-center text-md-start"
                  ><img
                    class="pb-2 pe-2"
                    src="@/assets/icons/instagram.svg"
                    alt=""
                  />
                  Instagram /
                </a>
                <br />
                <a
                  href="https://twitter.com/DerekAddict"
                  target="_blank"
                  class="text-center text-md-start"
                  ><img
                    class="pb-2 pe-2"
                    src="@/assets/icons/twitter.svg"
                    alt=""
                  />
                  Twitter /
                </a>
              </div>
              <div class="w-100 d-none d-md-flex">
                <a target="_blank" href="https://www.sic.gov.co/">
                  <img
                    src="@/assets/icons/industriaycomercio.svg"
                    aria-label="Icon industria y comercio"
                    class="my-auto mb-4 ms-md-5"
                  />
                </a>
              </div>
              <div
                class="content-medios-pago mt-auto p-2 mb-0 d-none d-md-flex"
              >
                <img
                  src="@/assets/icons/mediosPago/visa.svg"
                  alt="icono visa"
                  style="max-width: 40px"
                />
                <img
                  src="@/assets/icons/mediosPago/mastercard.svg"
                  alt="icono mastercard"
                  style="max-width: 32px"
                />
                <img
                  src="@/assets/icons/mediosPago/diners.svg"
                  alt="icono diners"
                  style="max-width: 66px"
                />
                <img
                  src="@/assets/icons/mediosPago/pse.svg"
                  alt="icono pse"
                  style="max-width: 33px"
                />
                <img
                  src="@/assets/icons/mediosPago/amex.svg"
                  alt="icono american express"
                  style="max-width: 32px"
                />
                <img
                  src="@/assets/icons/mediosPago/efecty.svg"
                  alt="icono efecty"
                  style="max-width: 58px"
                />
                <img
                  src="@/assets/icons/mediosPago/nequi.svg"
                  alt="icono nequi"
                  style="max-width: 72px"
                />
                <img
                  src="@/assets/icons/mediosPago/daviplata.svg"
                  alt="icono daviplata"
                  style="max-width: 38px"
                />
                <img
                  src="@/assets/icons/mediosPago/rappi.svg"
                  alt="icono rappi"
                  style="max-width: 39px"
                />
                <img
                  src="@/assets/icons/mediosPago/addi.svg"
                  alt="icono addi"
                  style="max-width: 47px"
                />
                <img
                  src="@/assets/icons/mediosPago/quac.svg"
                  alt="icono quac"
                  style="max-width: 60px"
                />
                <img
                  src="@/assets/icons/mediosPago/sistecredito.svg"
                  alt="icono sistecredito"
                  style="max-width: 82px; width: 100%;"
                />
              </div>
            </div>
          </div>
          <div class="d-flex flex-wrap col-12 col-md-8">
            <div class="col-12 col-md-4">
              <p class="titulo-section-footer ps-lg-4">
                ATENCIÓN AL CLIENTE
              </p>
              <div class="d-grid ps-lg-4">
                <p class="mb-3">
                  <b>WhatsApp</b>
                  <br />
                  <a
                    target="_blank"
                    href="https://api.whatsapp.com/send?phone=573232747474&text=Hola!%20Quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20producto"
                  >
                    323 274 7474
                  </a>
                </p>
                <p class="mb-3">
                  <b>Línea nacional</b>
                  <br />
                  <a href="tel:018000423550"> 01 8000 423550 </a>
                </p>
                <p class="mb-3">
                  <b>Correo electrónico</b>
                  <br />
                  <a href="mailto:servicioalcliente@derek.co">
                    servicioalcliente@derek.co
                  </a>
                </p>
                <p class="mb-3">
                  <b>Horario de atención</b>
                  <br />
                  Lunes a viernes 8:00 am a 7:00 pm
                  <br />
                  Sábados 8:30 am a 5:30 pm
                </p>
                <p class="mb-3">
                  <b>Radicación PQRS</b>
                  <br />
                  <a
                    class="mb-3"
                    target="_blank"
                    href="https://grupobaguer.com/pqrs.php?BAGUER"
                  >
                    Radica tu PQR aquí
                  </a>
                </p>
              </div>
            </div>
            <div class="col-12 col-md-4">
              <p class="titulo-section-footer ps-lg-4">
                INFORMACIÓN
              </p>
              <div class="d-grid ps-lg-4">
                <div
                  v-for="(politica, index) in pagesStaticas"
                  :key="index"
                  :class="politica.tipo_pagina == 0 ? 'mb-3' : ''"
                >
                  <router-link
                    v-if="politica.tipo_pagina == 0"
                    :to="{ name: 'Politicas', params: { slug: politica.slug } }"
                    >{{ politica.titulo }}</router-link
                  >
                </div>
                <router-link class="mb-3" :to="{ name: 'Preguntasfrecuentes' }"
                  >Preguntas frecuentes</router-link
                >
                <router-link class="mb-3" :to="{ name: 'Tiendas' }"
                  >Encuentra una tienda</router-link
                >
                <router-link class="mb-3" :to="{ name: 'FollowOrder' }"
                  >Sigue tu pedido</router-link
                >
                <a class="mb-3" href="https://portalpagos.derek.co">
                  Paga tu cuota
                </a>
                <router-link class="mb-3" :to="{ name: 'Returns' }"
                  >Devoluciones</router-link
                >
                <router-link class="mb-3" :to="{ name: 'Sizeguide' }"
                  >Guía de tallas</router-link
                >
                <!-- <router-link class="mb-3" :to="{ name: 'Franquicia' }"
                  >Franquicias</router-link
                > -->
              </div>
            </div>
            <div class="col-12 col-md-4">
              <p class="titulo-section-footer ps-lg-4">
                POLÍTICAS
              </p>
              <div class="d-grid ps-lg-4">
                <div
                  v-for="(politica, index) in dataPoliticas"
                  :key="index"
                  class="mb-1"
                >
                  <router-link
                    v-if="politica.tipo_pagina == 0"
                    :to="{ name: 'Politicas', params: { slug: politica.slug } }"
                    >• {{ politica.titulo }}</router-link
                  >
                </div>
                <div class="mb-1">
                  <a
                    href="https://centroderelevo.gov.co/632/w3-channel.html"
                    target="_blank"
                  >
                    • Servicio para personas ciegas y sordociegas
                  </a>
                </div>
              </div>
            </div>
            <div
              class="content-medios-pago mt-auto p-2 mb-0 d-flex d-md-none mb-2"
              style="background-color: #FAFAFA; margin: auto -2rem"
            >
              <img
                src="@/assets/icons/mediosPago/visa.svg"
                alt="icono visa"
                style="max-width: 40px"
              />
              <img
                src="@/assets/icons/mediosPago/mastercard.svg"
                alt="icono mastercard"
                style="max-width: 32px"
              />
              <img
                src="@/assets/icons/mediosPago/diners.svg"
                alt="icono diners"
                style="max-width: 66px"
              />
              <img
                src="@/assets/icons/mediosPago/pse.svg"
                alt="icono pse"
                style="max-width: 33px"
              />
              <img
                src="@/assets/icons/mediosPago/amex.svg"
                alt="icono american express"
                style="max-width: 32px"
              />
              <img
                src="@/assets/icons/mediosPago/efecty.svg"
                alt="icono efecty"
                style="max-width: 58px"
              />
              <img
                src="@/assets/icons/mediosPago/nequi.svg"
                alt="icono nequi"
                style="max-width: 72px"
              />
              <img
                src="@/assets/icons/mediosPago/daviplata.svg"
                alt="icono daviplata"
                style="max-width: 38px"
              />
              <img
                src="@/assets/icons/mediosPago/rappi.svg"
                alt="icono rappi"
                style="max-width: 39px"
              />
              <img
                src="@/assets/icons/mediosPago/addi.svg"
                alt="icono addi"
                style="max-width: 47px"
              />
              <img
                src="@/assets/icons/mediosPago/quac.svg"
                alt="icono quac"
                style="max-width: 60px"
              />
              <img
                src="@/assets/icons/mediosPago/sistecredito.svg"
                alt="icono sistecredito"
                style="max-width: 82px"
              />
            </div>
            <div class="col-12 px-4 px-md-5 py-2">
              <p class="date-footer w-100">
                © Todos los derechos reservados a Baguer S.A.S.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <button-help /> -->
  </footer>
</template>
<script>
// import ButtonHelp from '@/components/Footer/ButtonHelp'
import NewsLatter from '@/components/Footer/NewsLatter'

import { mapState, mapActions } from 'vuex'
import { GA4SignUp } from '@/GA4/events'
import { sendFBQEvent } from '@/fbq'
export default {
  components: { /* ButtonHelp ,*/ NewsLatter },
  data() {
    return {
      tipoFooter: 1,
      validateStep1: false,
      validateStep2: false,
      validateStep3: false,
      showDiscound: false,
      correo: '',
      stepNewslatter: 0,
      day: null,
      month: null,
      tel: '',
      cel_newslatter: false,
      stateNewslatter: {
        title: 'Únete a la comunidad derek',
        text:
          'Entérate de las últimas noticias del mundo derek, lanzamientos de colecciones, eventos exclusivos, descuentos y mucho más.',
      },
      tyc: true,
      dataPoliticas: [],
      pagesStaticas: [],
    }
  },
  computed: {
    /* eslint-disable */
    ...mapState('user', ['errorNewsLatter', 'msgerrorNewsLatter']),
    validateEmail() {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(this.correo)
    },
    validatePhone() {
      if (!this.cel_newslatter) {
        return true
      } else {
        const re = /^3[0-9]{9}/
        return re.test(this.tel) && this.tel.length < 11
      }
    },
  },
  async mounted() {
    await this.axios({
      method: 'GET',
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
      url: 'layouts/get_footer',
    })
      .then(response => {
        this.pagesStaticas = response.data.bloque1
        this.dataPoliticas = response.data.bloque2
      })
      .catch(error => {
        console.log(error)
      })
  },
  watch: {
    day() {
      if (this.month) {
        this.validateStep1 = false
      }
    },
    month() {
      if (this.day) {
        this.validateStep1 = false
      }
    },
    cel_newslatter() {
      if (this.cel_newslatter) {
      } else {
        if (this.tyc) {
          this.validateStep3 = false
        }
      }
    },
  },
  methods: {
    ...mapActions('user', ['suscribeDerek']),
    validateSendDataNewsLatter() {
      if (this.tyc) {
        if (
          !this.cel_newslatter ||
          (this.cel_newslatter && this.validatePhone)
        ) {
          this.validateStep3 = false
          this.validateDataNewsLatter()
        } else {
          this.validateStep3 = true
        }
      } else {
        this.validateStep3 = true
      }
    },
    async validateDataNewsLatter() {
      if (this.validateEmail) {
        await this.suscribeDerek({
          correo: this.correo,
          day: this.day,
          month: this.month,
          sms: this.cel_newslatter ? 1 : 0,
          tel: this.tel ? this.tel : '',
          step: 2,
        }).then(() => {
          if (!this.errorNewsLatter) {
            this.stateNewslatter = {
              title: '¡Bienvenida!',
              text: 'Haces parte de la comunidad más exclusiva de la moda.',
            }
            document.cookie = 'email=' + this.correo
            this.$bvModal.show('modal-done-newsletter')
            sendFBQEvent(this, 'Subscribe', {})
            GA4SignUp('NewsLatter')
            this.correo = ''
            this.stepNewslatter += 1
          }
        })
      } else {
        this.$store.state.user.errorNewsLatter = true
      }
    },
    async validateService() {
      if (this.validateEmail) {
        await this.suscribeDerek({
          correo: this.correo,
          day: this.day,
          month: this.month,
          sms: this.cel_newslatter ? 1 : 0,
          tel: this.tel ? this.tel : '',
          step: 1,
        }).then(() => {
          if (!this.msgerrorNewsLatter) {
            this.stepNewslatter += 1
          }
        })
      } else {
        this.validateStep2 = true
      }
    },
  },
}
</script>
